export enum StockType {
  Saham = 'saham',
  Right = 'right',
  Waran = 'waran',
  Index = 'index',
  IndexAsing = 'index_asing',
  Reksadana = 'reksadana',
  Commodities = 'commodities',
  Crypto = 'crypto',
  Fx = 'fx',
  Etf = 'etf',
  Bond = 'bond',
}
